import React, { memo } from 'react';
import Button from '../../../../Button/Button';
import styles from './DataTableFilterDrawerFooter.module.scss';

interface DataTableFilterDrawerFooterProps {
    onSave: () => void;
    onClearAll: () => void;
    saveDisabled?: boolean;
    clearDisabled?: boolean;
    saveText?: string;
    cancelText?: string;
}

const DataTableFilterDrawerFooter: React.FC<DataTableFilterDrawerFooterProps> = ({
    onSave,
    onClearAll,
    saveDisabled = false,
    clearDisabled,
    saveText = 'Save',
    cancelText = 'Clear All',
}) => {
    const isClearDisabled = clearDisabled ?? saveDisabled;

    return (
        <div className={styles.Footer}>
            <div className={styles.PrimaryActions}>
                {/* Clear All must stay clickable when filters are applied but unchanged —
                    gating it on saveDisabled deadlocks clearing (no changes → can't clear) */}
                {/* Visuals live in the module classes (incl. :disabled) — no inline styles */}
                <Button
                    className={styles.CancelButton}
                    type="button"
                    onClick={onClearAll}
                    disabled={isClearDisabled}
                    text={cancelText}
                    style={{ margin: 0 }}
                />
                <Button
                    className={styles.SaveButton}
                    type="button"
                    onClick={onSave}
                    disabled={saveDisabled}
                    text={saveText}
                    style={{ margin: 0 }}
                />
            </div>
        </div>
    );
};

export default memo(DataTableFilterDrawerFooter);
